/* EnviAir — FAQ search.
   The accordion itself is native <details>; this only filters it. */
(function () {
  function init(root) {
    if (root.dataset.eaFaqReady) return;
    root.dataset.eaFaqReady = 'true';

    var wrap = root.querySelector('[data-ea-faq-search]');
    var input = root.querySelector('[data-ea-faq-input]');
    var empty = root.querySelector('[data-ea-faq-empty]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ea-faq-item]'));

    if (!wrap || !input || !items.length) return;

    // Cache the searchable text once; textContent per keystroke is wasteful.
    var haystacks = items.map(function (item) {
      return item.textContent.toLowerCase().replace(/\s+/g, ' ');
    });

    // Remembered so clearing the box puts the accordion back as it started
    // rather than leaving everything collapsed.
    var initiallyOpen = items.map(function (item) {
      return item.open;
    });

    // Only reveal the field now that it can actually do something.
    wrap.hidden = false;

    function filter() {
      var q = input.value.trim().toLowerCase();
      var hits = 0;

      items.forEach(function (item, i) {
        var match = !q || haystacks[i].indexOf(q) !== -1;
        item.hidden = !match;
        if (match) hits++;

        // Open matches while searching so the answer is visible without a
        // second click; restore the starting state when the query clears.
        item.open = q ? match : initiallyOpen[i];
      });

      if (empty) empty.hidden = hits !== 0;
    }

    input.addEventListener('input', filter);

    // Escape clears rather than leaving a stale filter behind.
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && input.value) {
        input.value = '';
        filter();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ea-faq]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-arm after a theme-editor re-render.
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-ea-faq]').forEach(init);
  });
})();
